import styled from 'styled-components';

/**
 * StatementUI
 *
 * Shared UI components and styled components for contact statements.
 * Universal styling that adapts to different contact types.
 */

export const Container = styled.div`
    margin-top: 16px;
    margin-bottom: 16px;

    .ant-card-body-content {
        padding: 0 !important;
    }
`;

export const TabContent = styled.div`
    min-height: 480px;
`;

export const StatementContainer = styled.div`
    .margin-left-auto {
        margin-left: auto;
    }

    .margin-right-auto {
        margin-right: auto;
    }

    .ant-tabs-nav {
        padding: 0 16px;
        margin: 0 0 4px 0;
        .ant-tabs-tab {
            padding: 8px 0;
            .ant-tabs-tab-btn {
                font-size: 0.75rem;
            }
        }
    }

    .ant-tabs-extra-content {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .statement-total-box-wrapper {
        background-color: ${(props) => props.theme.SelectedBackgroundColor};
        margin-top: 1px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 1.25rem;

        border-bottom: ${(props) => props.theme.DefaultBorder};
        padding: 1rem 2rem;
        width: 100%;

        .statement-filter {
            small {
                display: block;
                text-transform: uppercase;
                font-size: ${(props) => props.theme.FontSizeSm};
            }
        }

        .statement-total-header {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            text-transform: capitalize;
            gap: 1rem;
            min-height: 3rem;

            .statement-total-header-icon {
                font-size: 2rem;
            }
            .statement-total-header-text {
                white-space: nowrap;
                h3 {
                    font-weight: 500;
                    margin: 0;
                }
            }
        }
        .statement-total-box {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            text-transform: uppercase;
            font-size: ${(props) => props.theme.FontSizeBase};
            gap: 1rem;
            border-left: ${(props) => props.theme.DefaultBorder};
            padding-left: 1rem;
            min-height: 3rem;

            &.statement-total-box-on-hold {
                /* color: ${(props) => props.theme.DangerColor}; */
                /* font-size: ${(props) => props.theme.FontSizeSm}; */
                color: ${(props) => props.theme.TextColorMuted};
            }

            .statement-total-box-icon {
                font-size: 1.25rem;
            }
            .statement-total-box-text {
                white-space: nowrap;
                p {
                    margin: 0;
                }
                small {
                    font-size: ${(props) => props.theme.FontSizeXSm};
                    display: block;
                    color: ${(props) => props.theme.TextColorMuted};
                    /* max-width: 7.25rem; */
                    white-space: normal;
                }
            }

            &:last-of-type {
                .statement-total-box-text {
                    /* text-align: right; */
                }
            }

            .statement-total-box-values {
                white-space: nowrap;
                p {
                    text-align: right;
                    margin: 0;
                    font-weight: bold;
                }
            }

            @media (max-width: 1600px) {
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 0.15rem;

                .statement-total-box-icon {
                    display: none;
                }
                .statement-total-box-text {
                    white-space: nowrap;
                    p {
                        margin: 0;
                    }
                    small {
                        font-size: ${(props) => props.theme.FontSizeXSm};
                        display: block;
                        color: ${(props) => props.theme.TextColorMuted};
                    }
                }

                &:last-of-type {
                    .statement-total-box-text {
                        text-align: left;
                    }
                }
            }
        }
    }

    .statement-navigation {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 2rem;
        border-bottom: ${(props) => props.theme.DefaultBorder};
        padding: 1rem 2rem;

        .statement-search {
            margin-left: auto;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 0.5rem;
        }

        .statement-filter {
            small {
                display: inline-block;
                margin-right: 0.5rem;
                text-transform: uppercase;
                font-size: ${(props) => props.theme.FontSizeSm};
            }
        }

        .statement-period-total-box {
            padding-left: 1rem;
            p,
            div {
                margin: 0;
                line-height: 1.25em;
            }
            h4 {
                margin: 0 0 0.25rem 0;
                font-size: ${(props) => props.theme.FontSizeSm};
                font-weight: 300;
                color: ${(props) => props.theme.TextColorMuted};
                text-transform: uppercase;
            }
            .statement-period-total-box-line {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                gap: 0.5rem;
                .statement-period-total-box-line-currency {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 0.5rem;

                    &:not(:first-of-type) {
                        &::before {
                            content: ' / ';
                        }
                    }
                }
            }
        }

        .statement-period-total-box-separator {
            color: ${(props) => props.theme.TextColorMuted};
        }
    }

    .statement-filters {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 2rem;
        padding: 1rem 2rem;

        .statement-filter {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 1rem;
            small {
                text-transform: uppercase;
                font-size: ${(props) => props.theme.FontSizeSm};
            }
        }
    }

    .statement-tools {
        padding: 1rem 2rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
`;

export const StatementTableContainer = styled.div`
    /* min-height: 386px; */
    padding-bottom: ${(props) => (props.$search ? '1rem' : '3.5rem')};

    .printable-statement-available-balance {
        /* display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        gap: 2rem; */
        padding: 0 1rem 1rem 0;

        h3 {
            display: block;
            text-transform: uppercase;
            /* text-align: right; */
            font-size: 0.9rem;
            margin: 0;
            line-height: 1.25em;
        }

        .printable-statement-available-balance-amounts {
            display: block;
            text-align: right;

            span {
                display: block;
                font-weight: 500;
                font-size: 0.9rem;
                line-height: 1.25em;
            }
        }
    }

    .printable-statement-period-balances {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        .printable-statement-period-balances-arrow {
            font-size: 1.5rem;
            color: ${(props) => props.theme.TextColorMuted};
        }
    }

    .printable-statement-inline-balances-group {
        h4 {
            margin: 0;
            font-size: ${(props) => props.theme.FontSizeSm};
            font-weight: 200;
            text-transform: uppercase;
        }
    }

    .printable-statement-inline-balances {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 1rem;
        margin-bottom: 0.25rem;
        font-size: ${(props) => props.theme.FontSizeSm};

        p {
            font-weight: 500;
            text-transform: uppercase;
            margin: 0;
            width: 13rem;
        }

        &.printable-statement-inline-balances-small {
            p {
                width: 6rem;
            }
        }

        .printable-statement-inline-balance-amounts {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 0.5rem;

            .printable-statement-inline-balance-amount {
                &:not(:first-of-type) {
                    &::before {
                        content: '/';
                        margin-right: 0.5rem;
                    }
                }
            }
        }
    }

    .printable-statement-totals {
        display: flex;
        justify-content: flex-end;
        align-items: stretch;
        margin-bottom: 2rem;

        .printable-statement-total {
            min-width: 9rem;
            border-right: ${(props) => props.theme.DefaultBorder};
            padding-right: 1rem;
            margin-left: 1rem;

            &:last-of-type {
                border-right: none;
            }

            h3 {
                display: block;
                text-transform: uppercase;
                font-weight: 200;
                text-align: right;
                font-size: 0.75rem;
            }

            .printable-statement-total-amounts {
                display: block;
                text-align: right;
                span {
                    display: block;
                    font-size: 0.75rem;
                    line-height: 1.2em;
                }
            }
        }
    }

    .statement-table {
        border-radius: 0;

        thead {
            border-radius: 0;
            tr {
                th {
                    padding: 0.25rem 0.5rem;
                    font-size: ${(props) => props.theme.FontSizeXSm};
                    text-transform: uppercase;
                    background-color: ${(props) => props.theme.LayoutBodyBackground};
                    font-weight: 300;
                }
                &:first-child {
                    th:first-child {
                        border-top-left-radius: 0;
                    }
                    th:last-child {
                        border-top-right-radius: 0;
                    }
                }
            }
        }
        tbody {
            tr {
                td {
                    //min-width: 4rem;
                    vertical-align: top;
                    padding: 0.25rem 0.5rem !important;

                    &.zoom-cursor {
                        cursor: zoom-in;
                    }

                    &.top-aligned {
                        vertical-align: top;
                    }

                    .date-container {
                        width: 4rem;
                    }

                    border-right: ${(props) => props.theme.DefaultBorder};

                    .transaction-status {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        min-height: 2.5rem;
                        width: 4rem;
                    }
                    .transaction-model-status,
                    .transaction-agency-status {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        min-height: 2.5rem;
                        gap: 0.5rem;
                        width: 3rem;

                        &.transaction-agency-status-bigger {
                            width: 5rem;
                        }
                    }

                    .model-invoice-status,
                    .model-payment-status {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .payment-status {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        min-height: 2.5rem;
                        width: 3rem;
                    }

                    .transaction-details {
                        padding: 0 0.5rem;

                        small {
                            display: block;
                            line-height: 1.5;
                        }
                    }
                    .project-details {
                        padding: 0 0.5rem;
                        h1 {
                            font-size: 0.85rem;
                        }
                        small {
                            display: block;
                            line-height: 1.5;
                        }
                    }

                    .transaction-gross {
                        padding: 0 0.25rem;
                        font-size: ${(props) => props.theme.FontSizeSm};
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        justify-content: flex-start;
                        white-space: nowrap;
                        width: 10rem;
                    }

                    .statement-total {
                        padding: 0 0.25rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;
                        align-items: flex-end;
                        //width: 8rem;
                        font-size: 0.9rem;
                        font-weight: 600;
                    }

                    p {
                        margin: 0;
                        line-height: 1.5em;

                        &.transaction-client {
                            font-size: 0.8rem;
                            font-weight: 700;
                            text-transform: uppercase;
                            cursor: pointer;
                        }
                        &.transaction-model {
                            font-size: 0.8rem;
                            font-weight: 700;
                            text-transform: uppercase;
                            cursor: pointer;
                        }
                        &.transaction-family-label {
                            font-size: 0.8rem;
                            font-weight: 700;
                            text-transform: uppercase;
                        }
                        &.transaction-family-title {
                            font-size: 1rem;
                        }
                        &.transaction-family-description {
                            font-size: 0.8rem;
                            opacity: 0.8;
                        }
                    }
                    .amount-label {
                        opacity: 0.5;
                        font-size: 0.65rem;
                        text-transform: uppercase;
                        display: block;
                        padding: 0;
                        margin-top: 0.4rem;

                        &:first-of-type {
                            margin-top: 0;
                        }
                    }
                    .amount-numbers {
                        line-height: 1em;
                        padding: 0 0 0.25rem 0;
                    }
                    .transaction-details-amount {
                        cursor: pointer;
                        text-align: right;
                    }

                    .tax-details {
                        font-size: 0.65rem;
                        display: block;
                        padding: 0;
                        line-height: 1em;
                    }

                    .transaction-final-amount {
                        cursor: pointer;
                        text-align: right;
                        .total {
                            font-size: 1rem;
                            font-weight: 500;
                        }
                        .icons {
                        }
                    }

                    .transaction-actions {
                        font-size: 1.15rem;
                        padding: 0.25rem 0.5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 1rem;
                        color: #000;

                        .nw-dropdown-menu-button-group {
                            align-items: baseline;
                        }
                    }
                }

                &.commission-row,
                &.advance-row {
                    td {
                        background-color: #f5f5f5;
                        padding: 0.15rem 0.5rem !important;
                        .transaction-status {
                            min-height: 1rem;
                        }
                        .transaction-details {
                            padding-top: 0.4rem;
                            small {
                                text-transform: uppercase;
                            }
                        }
                        .commission-perc {
                            padding: 0.4rem 0.5rem;
                            font-size: ${(props) => props.theme.FontSizeSm};
                        }
                    }
                }
                &.fee-row {
                    td {
                        border-bottom: 1px dashed ${(props) => props.theme.LighterBorderColor};
                    }
                }

                &.statement-row-paid {
                    td {
                        background-color: ${(props) => props.theme.SelectedBackgroundColor};
                        color: ${(props) => props.theme.TextColorMuted} !important;
                        .transaction-details {
                            .transaction-title {
                                color: ${(props) => props.theme.TextColorMuted} !important;
                                font-weight: 300 !important;
                            }
                        }
                        .project-details {
                            strong,
                            h1,
                            p {
                                color: ${(props) => props.theme.TextColorMuted} !important;
                                font-weight: 300 !important;
                            }
                        }
                    }
                }

                &.statement-row-payment {
                    td {
                        background-color: ${(props) => props.theme.LightBlueBackground};
                    }
                }

                &.cancelled {
                    .transaction-title,
                    .statement-total,
                    .transaction-commission-name {
                        ${(props) => props.theme.RedLineThrough(1)};
                    }
                }
            }

            :nth-of-type(1) {
                td {
                    border-top: none;
                }
            }
        }

        tfoot.ant-table-summary {
            tr {
                td {
                    padding: 0.5rem 1rem;
                    vertical-align: top;
                    border-bottom: 2px solid ${(props) => props.theme.PrimaryColor};
                    border-left: 1px solid ${(props) => props.theme.BorderColor};
                    border-right: 1px solid ${(props) => props.theme.BorderColor};
                    border-top: 2px solid ${(props) => props.theme.PrimaryColor};
                    /* background-color: ${(props) => props.theme.LayoutBodyBackground}; */

                    .summary-icon-wrapper {
                        color: ${(props) => props.theme.PrimaryColor};
                        font-size: 1.5rem;
                        text-align: center;
                    }
                }
            }
        }

        &.statement-table-payment {
            tbody {
                tr {
                    td {
                        cursor: pointer;
                    }
                }
            }
        }
        &.statement-table-previsional {
            tbody {
                tr {
                    td {
                        font-style: italic;
                        font-weight: 100;
                        .transaction-details {
                            .transaction-title {
                                font-weight: 100 !important;
                            }
                        }
                        .project-details {
                            h1 {
                                font-size: 0.85rem;
                            }
                            strong,
                            h1,
                            p {
                                font-weight: 100 !important;
                            }
                        }
                    }
                }
            }
        }
        &.statement-table-hold {
            tbody {
                tr {
                    td {
                        color: ${(props) => props.theme.DangerColor};
                        font-weight: 100;
                        .transaction-details {
                            .transaction-title {
                                font-weight: 100 !important;
                            }
                        }
                        .project-details {
                            h1 {
                                font-size: 0.85rem;
                            }
                            strong,
                            h1,
                            p {
                                font-weight: 100 !important;
                            }
                        }
                    }
                }
            }
        }

        &.statement-table-printable {
            thead {
                tr {
                    th {
                        vertical-align: top;
                    }
                }
            }

            tbody {
                tr {
                    td {
                        &:nth-of-type(1) {
                            border-left: ${(props) => props.theme.DefaultBorder};
                        }
                    }
                    &.statement-row-paid {
                        td {
                            background-color: white;
                        }
                    }
                }
            }

            tfoot.ant-table-summary {
                tr {
                    td {
                        padding: 0.5rem 1rem;
                        border: none;
                        vertical-align: top;
                    }
                }
            }

            .statement-total {
                white-space: nowrap;
            }
            small.payment-status {
                text-align: center;
                display: block;
                margin-top: 0.25rem;
                line-height: 1.1em;
                font-size: ${(props) => props.theme.FontSizeSm};
            }
        }
    }

    .ant-pagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .ant-typography-ellipsis-single-line {
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        white-space: unset;
    }
`;

export const PrintableDrawerWrapper = styled.div`
    .printable-statement-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding-bottom: 1rem;
        padding-top: 1rem;
        padding-right: 2rem;
        padding-left: 1rem;

        .switch-holder {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 0.75rem;
            gap: 1.5rem;
        }

        .printable-statement-header-left {
        }
        .printable-statement-header-right {
            font-size: 2rem;
        }
    }
`;
